import $ from "jquery";
import bdjs from "@bd-core/bdjs";

const GameLogic = {
    async init() {
        if ($(".app").length < 1) return false;

        try {
            bdjs.hideLoading();
        } catch (e) {
            console.error(e);
        }
    },

    registerGlobalListener() {
    },

    registerGlobalEvents() {
    },

    /**
     * This function is to listen an event when game progress was edited from backend
     */
    listenGameProgressChanged() {
    },
};

export default GameLogic;
